import { CogSyncIcon } from './CogSyncIcon';

/**
 * author: Michael Irigoyen
 * id BEC36759-CFB0-4475-A65B-B10F860E850A
 * name cog-sync
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-sync.svg
 * tags
 * - Settings 
 */
export const SettingsSyncIcon = CogSyncIcon;
export default SettingsSyncIcon